import {
  Component,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-search-res-number',
  templateUrl: './search-res-number.component.html',
})
export class SearchResNumberComponent {
  @Output() public onChange = new EventEmitter();
  @Input() public value: number;
  @Input() public isTopOriented: string;
  @Input() public focus$: Observable<undefined>;

  public onDropdownChange(value: number) {
    this.onChange.emit(value);
  }
}
